export default {
  highcharts: {
    decimalPoint: ',',
    downloadJPEG: 'Pobierz obraz JPEG',
    downloadPDF: 'Pobierz dokument PDF',
    downloadPNG: 'Pobierz obraz PNG',
    downloadSVG: 'Pobierz obraz SVG',
    exportButtonTitle: 'Eksport',
    forexRate: 'Kurs średni FOREX',
    loading: 'Ładowanie...',
    months: [
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień',
    ],
    printButtonTitle: 'Drukowanie',
    rangeSelectorFrom: 'Od',
    rangeSelectorTo: 'Do',
    rangeSelectorZoom: 'Przybliżenie',
    rateTypes: {
      ask: 'Najlepsza oferta sprzedaży',
      bid: 'Najlepsza oferta kupna',
      forex: 'Średni kurs na świecie',
    },
    resetZoom: 'Reset',
    resetZoomTitle: 'Reset',
    shortMonths: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
    thousandsSep: ' ',
    weekdays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    wtBestAsk: 'Najlepsza oferta sprzedaży',
    wtBestBid: 'Najlepsza oferta kupna',
  },
  calculator: {
    title: 'Розрахуйте свої заощадження у Walutomat',
    forBuy: 'за',
    unsupportedPair: 'На даний момент ми не надаємо курси для вибраної пари валют.',
    spinnerError: {
      generic: 'Під час завантаження даних виникла проблема',
      toManyRequests:
        'Зараз калькулятором користується дуже багато користувачів. Спробуй пізніше або звернись до Відділу Обслуговування Клієнта <a href="https://www.walutomat.com/uk/kontakt/">https://www.walutomat.com/uk/kontakt/</a>.',
    },
    commissionWT: 'Комісія Walutomat',
    continueButton: 'Продовжити обмін',
    amountText: 'Вартість',
  },
  continueButton: {
    createAccount: 'Створити безкоштовний акаунт',
    logIn: 'Увійти',
    check: 'Перевірити',
    checkWhyWorth: 'чому це варто',
  },
  calculatorForegin: {
    exchangeRates: 'Курс обміну',
    details: 'Деталі',
    amountYouSend: 'Сума, яку я сплачую',
    countryYouSendMoney: 'Країна, до якої ви надсилаєте гроші',
    foreignTransferFee: 'Комісія за міжнародний переказ',
    foreignTransferType: 'Тип міжнародного переказу',
    exchangeAmount: 'Сума обміну',
    amountRecipientReceive: 'Сума, яку отримає одержувач',
    minAmount: 'Сума обміну занадто низька',
    notSellCurrency: 'Продаж валюти недоступна.',
    continueButton: 'Продовжити обмін',
    noCurrenciesSupportedInfo: 'Пара валют не підтримується',
    noCountrySupportedInfo: 'Ми не обслуговуємо обрану пару в даній країні.',
    enterAmount: 'Введіть суму',
    commissionWT: 'Комісія Walutomat',
    equivalentFee: 'Еквівалент',
    commissionAmount: '{{fee_percent}}%  від загальної суми',
  },
  timer: {
    update: 'Оновлення за:',
    timeUnit: 'сек.',
  },
  dashboard: {
    canEditPost: 'Możesz edytować wpis',
    postExists: 'Wpis o takim tytule już istnieje',
    postNotExists: 'Wpis o takim tytule nie istnieje',
    emptyPostTitle: 'Dodaj tytuł wpisu',
    error: 'Coś poszło nie tak :(',
  },
  widgetCalculator: {
    title: 'Перевір курси та{{nbsp}}обміняй валюту у{{nbsp}}Walutomat – швидко та{{nbsp}}вигідно.',
    actualRate: 'Актуальний курс',
    buySelect: 'Купую',
    sellSelect: 'Продаю',
    buttonText: 'Обміняти',
    exchangeAmountSellLabel: 'Ви отримаєте',
    exchangeAmountBuyLabel: 'Внесіть',
    commission: 'Промо-комісія ({{commission}}%)',
  },
  formValidation: {
    emptyField: "Обов'язкове поле",
    requiredField: "Обов'язкове поле",
    requireAllFields: 'Усі поля мають бути заповнені',
    passwordToShort: 'Пароль повинен містити не менше 8 символів',
    emailNotValid: 'поле має містити правильний адрес електронної пошти',
    emailReserved: 'Даний email вже зайнятий',
    emailUnregistered: 'Не знайшли вашого електронного адреси в базі наших клієнтів.',
    markField: 'Позначте принаймні один з прапорців',
    serverUnknownError: "Помилка зв'язку з сервером.",
    invalidCharacters: 'Поле містить недопустимі символи',
    phoneNotValid: 'Номер телефону є недійсним',
    checkBoxBelow: 'Будь ласка, позначте поле нижче, щоб надіслати повідомлення',
    promocodeInvalid: 'Неправильний промокод',
    newsletterAlreadySubscribed: 'Ця електронна адреса вже підписана на розсилку новин.',
  },
  password: {
    show: 'шоу',
    hide: 'приховати',
  },
  howItWorks: {
    showButton: 'показати більше',
    hideButton: 'показувати менше',
  },
  transferTypes: {
    elixir: {
      header: 'Звичайний',
      subtext: 'Гроші надійдуть протягом 2 - 3 робочих днів.',
      subtextNoAdditionalCosts:
        'При переказі {{currency}} до {{country}} банки зазвичай не стягують додаткових комісій за переказ.',
      subtextPayoutInPoland: 'За перекази в межах Польщі банки зазвичай не стягують жодних додаткових комісій.',
      subtextSelf: 'Гроші надійдуть протягом 2 - 3 робочих днів.',
      subtextWarning: 'Увага: банки можуть стягувати додаткову комісію, яка залежить від валюти та країни призначення.',
    },
    internal: {
      header: 'Звичайний',
      subtext: 'Гроші надійдуть найпізніше наступного робочого дня.',
      subtextNoAdditionalCosts:
        'При переказі {{currency}} до {{country}} банки зазвичай не стягують додаткових комісій за переказ.',
      subtextPayoutInPoland: 'За перекази в межах Польщі банки зазвичай не стягують жодних додаткових комісій.',
      subtextSelf: 'Гроші надійдуть найпізніше наступного робочого дня.',
      subtextWarning: 'Увага: банки можуть стягувати додаткову комісію, яка залежить від валюти та країни призначення.',
    },
    internal_bre: {
      header: 'Звичайний',
      subtext: 'Гроші надійдуть протягом 2 - 3 робочих днів.',
      subtextNoAdditionalCosts:
        'При переказі {{currency}} до {{country}} банки зазвичай не стягують додаткових комісій за переказ.',
      subtextPayoutInPoland: 'За перекази в межах Польщі банки зазвичай не стягують жодних додаткових комісій.',
      subtextSelf: 'Гроші надійдуть протягом 2 - 3 робочих днів.',
      subtextWarning: 'Увага: банки можуть стягувати додаткову комісію, яка залежить від валюти та країни призначення.',
    },
    sepa: {
      header: 'Звичайний',
      subtext: 'Гроші надійдуть протягом 1 - 2 робочих днів.',
      subtextNoAdditionalCosts:
        'При переказі {{currency}} до {{country}} банки зазвичай не стягують додаткових комісій за переказ.',
      subtextPayoutInPoland: 'За перекази в межах Польщі банки зазвичай не стягують жодних додаткових комісій.',
      subtextSelf: 'Гроші надійдуть протягом 1 - 2 робочих днів.',
      subtextWarning: 'Увага: банки можуть стягувати додаткову комісію, яка залежить від валюти та країни призначення.',
    },
    sorbnet: {
      header: 'Експрес-переказ',
      subtext: 'Гроші надійдуть найпізніше наступного робочого дня.',
      subtextNoAdditionalCosts:
        'При переказі {{currency}} до {{country}} банки зазвичай не стягують додаткових комісій за переказ.',
      subtextPayoutInPoland: 'За перекази в межах Польщі банки зазвичай не стягують жодних додаткових комісій.',
      subtextSelf: 'Гроші надійдуть найпізніше наступного робочого дня.',
      subtextWarning: 'Увага: банки можуть стягувати додаткову комісію, яка залежить від валюти та країни призначення.',
    },
    spot: {
      header: 'Звичайний',
      subtext: 'Гроші надійдуть протягом 2 - 3 робочих днів.',
      subtextNoAdditionalCosts:
        'При переказі {{currency}} до {{country}} банки зазвичай не стягують додаткових комісій за переказ.',
      subtextPayoutInPoland: 'За перекази в межах Польщі банки зазвичай не стягують жодних додаткових комісій.',
      subtextSelf: 'Гроші надійдуть протягом 2 - 3 робочих днів.',
      subtextWarning: 'Увага: банки можуть стягувати додаткову комісію, яка залежить від валюти та країни призначення.',
    },
    swift_usd: {
      header: 'Звичайний',
      subtext: 'Гроші надійдуть протягом 2 - 3 робочих днів.',
      subtextNoAdditionalCosts:
        'При переказі {{currency}} до {{country}} банки зазвичай не стягують додаткових комісій за переказ.',
      subtextPayoutInPoland: 'За перекази в межах Польщі банки зазвичай не стягують жодних додаткових комісій.',
      subtextSelf: 'Гроші надійдуть протягом 2 - 3 робочих днів.',
      subtextWarning: 'Увага: банки можуть стягувати додаткову комісію, яка залежить від валюти та країни призначення.',
    },
    today: {
      header: 'Експрес-переказ',
      subtext: 'Гроші надійдуть найпізніше наступного робочого дня.',
      subtextNoAdditionalCosts:
        'При переказі {{currency}} до {{country}} банки зазвичай не стягують додаткових комісій за переказ.',
      subtextPayoutInPoland: 'За перекази в межах Польщі банки зазвичай не стягують жодних додаткових комісій.',
      subtextSelf: 'Гроші надійдуть найпізніше наступного робочого дня.',
      subtextWarning: 'Увага: банки можуть стягувати додаткову комісію, яка залежить від валюти та країни призначення.',
    },
    today_our: {
      header: 'Експрес-переказ (OUR)',
      subtext:
        'Гроші надійдуть найпізніше наступного робочого дня. Гарантія того, що одержувач отримає повну суму, а банки не стягуватимуть жодних додаткових комісій по дорозі.',
      subtextSelf:
        'Гроші надійдуть найпізніше наступного робочого дня. Гарантія того, що одержувач отримає повну суму, а банки не стягуватимуть жодних додаткових комісій по дорозі.',
      subtextNoAdditionalCosts: '',
      subtextPayoutInPoland: '',
      subtextWarning: '',
    },
    sepa_instant: {
      header: 'Миттєвий',
      subtext: 'Гроші надійдуть приблизно за 1 хвилину.',
      subtextSelf: 'Гроші надійдуть приблизно за 1 хвилину.',
      subtextWarning: 'Миттєвий переказ можливий тільки до суми {{maxAmount}}.',
      subtextNoAdditionalCosts: '',
      subtextPayoutInPoland: '',
    },
    local: {
      header: 'Експрес-переказ',
      subtext: 'Гроші надійдуть найпізніше наступного робочого дня.',
      subtextSelf: 'Гроші надійдуть найпізніше наступного робочого дня.',
      subtextNoAdditionalCosts: '',
      subtextPayoutInPoland: '',
      subtextWarning: '',
    },
    local_express: {
      header: 'Миттєвий',
      subtext: 'Гроші надійдуть приблизно через 30 хвилин, не пізніше наступного робочого дня.',
      subtextSelf: 'Гроші надійдуть приблизно через 30 хвилин, не пізніше наступного робочого дня.',
      subtextNoAdditionalCosts: '',
      subtextPayoutInPoland: '',
      subtextWarning: 'Миттєвий переказ можливий тільки до суми {{maxAmount}}.',
    },
    trustedAccountInfo:
      'Виплати на цей рахунок не потрібно підтверджувати SMS-кодом або додатком (це можна змінити в налаштуваннях банківського рахунку).',
    walletWidgetTransferAll: 'Виплатити все',
  },
  countries: {
    AD: 'Андорра',
    AE: "Об'єднані Арабські Емірати",
    AF: 'Афганістан',
    AG: 'Антигуа і Барбуда',
    AI: 'Ангілья',
    AL: 'Албанія',
    AM: 'Вірменія',
    AN: 'Нідерландські Антильські острови',
    AO: 'Ангола',
    AQ: 'Антарктида',
    AR: 'Аргентина',
    AS: 'Американське Самоа',
    AT: 'Австрія',
    AU: 'Австралія',
    AW: 'Аруба',
    AX: 'Аландські острови',
    AZ: 'Азербайджан',
    BA: 'Боснія і Герцеговина',
    BB: 'Барбадос',
    BD: 'Бангладеш',
    BE: 'Бельгія',
    BF: 'Буркіна-Фасо',
    BG: 'Болгарія',
    BH: 'Бахрейн',
    BI: 'Бурунді',
    BJ: 'Бенін',
    BL: 'Сен-Бартелемі',
    BM: 'Бермудські острови',
    BN: 'Бруней-Даруссалам',
    BO: 'Болівія',
    BR: 'Бразилія',
    BS: 'Багамські острови',
    BT: 'Бутан',
    BV: 'Острів Буве',
    BW: 'Ботсвана',
    BY: 'Білорусь',
    BZ: 'Беліз',
    CA: 'Канада',
    CC: 'Кокосові острови',
    CD: 'Демократична Республіка Конго',
    CF: 'Центральноафриканська Республіка',
    CG: 'Республіка Конго',
    CH: 'Швейцарія',
    CI: "Кот-д'Івуар",
    CK: 'Острови Кука',
    CL: 'Чилі',
    CM: 'Камерун',
    CN: 'Китай',
    CO: 'Колумбія',
    CR: 'Коста-Рика',
    CU: 'Куба',
    CV: 'Кабо-Верде',
    CW: 'Кюрасао',
    CX: 'Острів Різдва',
    CY: 'Кіпр',
    CZ: 'Чехія',
    DE: 'Німеччина',
    DJ: 'Джибуті',
    DK: 'Данія',
    DM: 'Домініка',
    DO: 'Домініканська Республіка ',
    DZ: 'Алжир',
    EC: 'Еквадор',
    EE: 'Естонія',
    EG: 'Єгипет',
    EH: 'Західна Сахара',
    ER: 'Еритрея',
    ES: 'Іспанія',
    ET: 'Ефіопія',
    FI: 'Фінляндія',
    FJ: 'Фіджі',
    FK: 'Фолклендські острови',
    FM: 'Мікронезія',
    FO: 'Фарерські острови',
    FR: 'Франція',
    GA: 'Габон',
    GB: 'Велика Британія',
    GD: 'Гренада',
    GE: 'Грузія',
    GF: 'Французька Гвіана',
    GG: 'Гернсі',
    GH: 'Гана',
    GI: 'Гібралтар',
    GL: 'Гренландія',
    GM: 'Гамбія',
    GN: 'Гвінея',
    GP: 'Гваделупа',
    GQ: 'Екваторіальна Гвінея',
    GR: 'Греція',
    GS: 'Південна Джорджія і Південні Сандвічеві Острови',
    GT: 'Гватемала',
    GU: 'Гуам',
    GW: 'Гвінея-Бісау',
    GY: 'Гаяна',
    HK: 'Гонконг',
    HM: 'Острів Герд і острови Макдональд',
    HN: 'Гондурас',
    HR: 'Хорватія',
    HT: 'Гаїті',
    HU: 'Угорщина',
    ID: 'Індонезія',
    IE: 'Ірландія',
    IL: 'Ізраїль',
    IM: 'Острів Мен',
    IN: 'Індія',
    IO: 'Британська територія в Індійському океані',
    IQ: 'Ірак',
    IR: 'Іран',
    IS: 'Ісландія',
    IT: 'Італія',
    JE: 'Джерсі',
    JM: 'Ямайка',
    JO: 'Йорданія',
    JP: 'Японія',
    KE: 'Кенія',
    KG: 'Киргизстан',
    KH: 'Камбоджа',
    KI: 'Кірибаті',
    KM: 'Коморські Острови',
    KN: 'Сент-Кіттс і Невіс',
    KP: 'Північна Корея',
    KR: 'Південна Корея',
    KW: 'Кувейт',
    KY: 'Кайманові Острови',
    KZ: 'Казахстан',
    LA: 'Лаос',
    LB: 'Ліван',
    LC: 'Сент-Люсія',
    LI: 'Ліхтенштейн',
    LK: 'Шрі-Ланка',
    LR: 'Ліберія',
    LS: 'Лесото',
    LT: 'Литва',
    LU: 'Люксембург',
    LV: 'Латвія',
    LY: 'Лівія',
    MA: 'Марокко',
    MC: 'Монако',
    MD: 'Молдова',
    ME: 'Чорногорія',
    MF: 'Сінт-Мартен',
    MG: 'Мадагаскар',
    MH: 'Маршаллові Острови',
    MK: 'Македонія',
    ML: 'Малі',
    MM: "М'янма",
    MN: 'Монголія',
    MO: 'Спеціальний адміністративний район Макао',
    MP: 'Північні Маріанські Острови',
    MQ: 'Мартиніка',
    MR: 'Мавританія',
    MS: 'Монтсеррат',
    MT: 'Мальта',
    MU: 'Маврикій',
    MV: 'Мальдіви',
    MW: 'Малаві',
    MX: 'Мексика',
    MY: 'Малайзія',
    MZ: 'Мозамбік',
    NA: 'Намібія',
    NC: 'Нова Каледонія',
    NE: 'Нігер',
    NF: 'Острів Норфолк',
    NG: 'Нігерія',
    NI: 'Нікарагуа',
    NL: 'Нідерланди',
    NO: 'Норвегія',
    NP: 'Непал',
    NR: 'Науру',
    NU: 'Ніуе',
    NZ: 'Нова Зеландія',
    OM: 'Оман',
    PA: 'Панама',
    PE: 'Перу',
    PF: 'Французька Полінезія',
    PG: 'Папуа Нова Гвінея',
    PH: 'Філіппіни',
    PK: 'Пакистан',
    PL: 'Польща',
    PM: "Сен-П'єр і Мікелон",
    PN: 'Піткерн',
    PR: 'Пуерто-Рико',
    PS: 'Палестина',
    PT: 'Португалія',
    PW: 'Палау',
    PY: 'Парагвай',
    QA: 'Катар',
    RE: 'Реюньйон',
    RO: 'Румунія',
    RS: 'Сербія',
    RU: 'Росія',
    RW: 'Руанда',
    SA: 'Саудівська Аравія',
    SB: 'Соломонові Острови',
    SC: 'Сейшельські Острови',
    SD: 'Судан',
    SE: 'Швеція',
    SG: 'Сінгапур',
    SH: 'Острів Святої Єлени',
    SI: 'Словенія',
    SJ: 'Свальбард і Ян-Маєн',
    SK: 'Словаччина',
    SL: 'Сьєрра-Леоне',
    SM: 'Сан-Марино',
    SN: 'Сенегал',
    SO: 'Сомалі',
    SR: 'Суринам',
    ST: 'Сан-Томе і Принсіпі',
    SV: 'Сальвадор',
    SY: 'Сирія',
    SZ: 'Есватіні',
    TC: 'Теркс і Кайкос',
    TD: 'Чад',
    TF: 'Французькі Південні і Антарктичні Території',
    TG: 'Того',
    TH: 'Таїланд',
    TJ: 'Таджикистан',
    TK: 'Токелау',
    TL: 'Східний Тимор',
    TM: 'Туркменістан',
    TN: 'Туніс',
    TO: 'Тонга',
    TR: 'Туреччина',
    TT: 'Тринідад і Тобаго',
    TV: 'Тувалу',
    TW: 'Тайвань',
    TZ: 'Танзанія',
    UA: 'Україна',
    UG: 'Уганда',
    UM: 'Зовнішні малі острови США',
    US: 'Сполучені Штати Америки',
    UY: 'Уругвай',
    UZ: 'Узбекистан',
    VA: 'Ватикан',
    VC: 'Сент-Вінсент і Гренадини',
    VE: 'Венесуела',
    VG: 'Британські Віргінські Острови',
    VI: 'Американські Віргінські Острови        ',
    VN: "В'єтнам",
    VU: 'Вануату',
    WF: 'Волліс і Футуна',
    WS: 'Самоа',
    XK: 'Косово',
    YE: 'Ємен',
    YT: 'Майотта',
    ZA: 'Південно-Африканська Республіка',
    ZM: 'Замбія',
    ZW: 'Зімбабве',
  },
  currencies: {
    ALL: 'Всі валюти',
    BGN: 'Болгарський лев',
    CHF: 'Швейцарський франк',
    CZK: 'Чеська крона',
    DKK: 'Данська крона',
    EUR: 'Євро',
    GBP: 'Фунт стерлінгів',
    NOK: 'Норвезька крона',
    PLN: 'Польський злотий',
    RON: 'Румунський лей',
    SEK: 'Шведська крона',
    USD: 'Долар США',
    ZAR: 'Південноафриканський ранд',
    TRY: 'Турецька ліра',
    SGD: 'Сінгапурський долар',
    RUB: 'Російський рубль',
    NZD: 'Новозеландський долар',
    MXN: 'Мексиканський песо',
    HKD: 'Гонконгський долар',
    CAD: 'Канадський долар',
    AUD: 'Австралійський долар',
    HUF: 'Угорський форинт',
    CNY: 'Китайський юань',
    ILS: 'Ізраїльський новий шекель',
    JPY: 'Японська єна',
    ARS: 'Аргентинський песо',
    BRL: 'Бразильський реал',
    CLP: 'Чилійський песо',
    COP: 'Колумбійський песо',
    UYU: 'Уругвайський песо',
    PEN: 'Перуанський соль',
    AED: 'дирхам ОАЕ',
    BDT: 'бангладешська така',
    EGP: 'єгипетський фунт',
    FJD: 'фіджійський долар',
    GHS: 'ганський седі',
    INR: 'індійська рупія',
    JOD: 'йорданський динар',
    KWD: 'Кувейтський динар',
    LSL: 'Лесото лоті',
    MAD: 'марокканський дирхам',
    NAD: 'Намібійський долар',
    NPR: 'Непальська рупія',
    OMR: 'оманський ріал',
    PGK: 'Папуа-Нова Гвінея кіна',
    PKR: 'пакистанська рупія',
    SAR: 'Саудівський ріал',
    SZL: 'Свазілендський лівенгень',
    THB: 'тайський бат',
    WST: 'Самоанська тала',
    allCurrenciesLabel: 'Всі',
    mainCurrenciesLabel: 'Основні валюти',
    restCurrenciesLabel: 'Інші:',
    converted: {
      BGN: 'болгарського лева',
      CHF: 'швейцарського франка',
      CZK: 'чеської крони',
      DKK: 'данської крони',
      EUR: 'євро',
      GBP: 'фунта стерлінгів',
      NOK: 'норвезької крони',
      PLN: 'польського злотого',
      RON: 'румунського лея',
      SEK: 'шведської крони',
      USD: 'долара США',
      ZAR: 'південноафриканського ранда',
      TRY: 'турецької ліри',
      SGD: 'сінгапурського долара',
      RUB: 'російського рубля',
      NZD: 'новозеландського долара',
      MXN: 'мексиканського песо',
      HKD: 'гонконгського долара',
      CAD: 'канадського долара',
      AUD: 'австралійського долара',
      HUF: 'угорського форинта',
      ARS: 'аргентинського песо',
      BRL: 'бразильського реала',
      CLP: 'чилійського песо',
      COP: 'колумбійського песо',
      UYU: 'уругвайського песо',
      PEN: 'перуанського соля',
      AED: 'дирхам ОАЕ',
      BDT: 'бангладешська така',
      CNY: 'китайський юань',
      EGP: 'єгипетський фунт',
      FJD: 'фіджійський долар',
      GHS: 'ганський седі',
      INR: 'індійська рупія',
      JOD: 'йорданський динар',
      KWD: 'Кувейтський динар',
      LSL: 'Лесото лоті',
      MAD: 'марокканський дирхам',
      NAD: 'Намібійський долар',
      NPR: 'Непальська рупія',
      OMR: 'оманський ріал',
      PGK: 'Папуа-Нова Гвінея кіна',
      PKR: 'пакистанська рупія',
      SAR: 'Саудівський ріал',
      SZL: 'Свазілендський лівенгень',
      THB: 'тайський бат',
      WST: 'Самоанська тала',
    },
  },
}
